import { FETCH_WASTE_DATA, DELETE_WASTE_DATA, FETCH_WASTE_SUCCESS, FETCH_WASTE_FAILURE } from "./actionTypes"

export const fetchWasteData = () => ({
  type: FETCH_WASTE_DATA,
})

export const fetchWasteSuccess = (data) => ({
  type: FETCH_WASTE_SUCCESS,
  payload: data,
});

export const fetchWasteFailure = (error) => ({
  type: FETCH_WASTE_FAILURE,
  payload: error,
});

export const deleteWasteData = () => ({
  type: DELETE_WASTE_DATA,
})
